module.exports = __webpack_public_path__ + "img/charge.ac6ec23c.png";